import React, { useEffect } from 'react';
import { enajenacion_item } from '../../json/enajenacionItem';
import './enajenacion.css';
import { Link } from 'react-router-dom';

const Enajenacion = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='title'>Enajenación de Bienes</h3>
                <hr className='hr-gob' />
            </div>
            <div className='row'>
                <div >
                    <Link className='colorlink_enajenacion' to="https://ruts.hidalgo.gob.mx/ver/5809">Enajenación de Bienes</Link>
                    <div className='enajenacion_descripcion'>
                        <h6>Consulta aqui el Servicio de Enajenación</h6>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='titulo_enajenacion' >         
                        <h6>Publicación de Convocatorias para Enajenación</h6>
                </div>

                {
                    enajenacion_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_enajenacion'>
                                <div className='card_anio'>
                                    <h5>{item.anio}</h5>
                                    {
                                        item.Convocatorias.map((trim, index) => (
                                            <div key={index} >
                                                <button className='btn2 btn-secondary dropdown-toggle' type='button' id='{trim.Convocatoria}' data-bs-toggle='dropdown' aria-expanded='false'>
                                                    {trim.Convocatoria}
                                                </button>
                                                <ul className='dropdown-menu' aria-labelledby='{trim.Convocatoria} '>
                                                    <li className='card_trimestre2_enajenacion'>
                                                        {
                                                            trim.Extras.map((trim2, index2) => (
                                                                <div key={index2}  >
                                                                    <a className='dropdown-item' href={trim2.url2} >{trim2.NombreValor} </a>
                                                                </div>
                                                            ))
                                                        }
                                                    </li>
                                                </ul>

                                            </div>
                                        ))
                                    }

                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div >

    )
}

export default Enajenacion